import { Component, OnInit, OnDestroy, ViewChild, forwardRef, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MatPaginator, MatSort, MatDialog } from "@angular/material";
import { ModuleConfiguration } from '../../security/security.module.config';
import { Store, Action } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import * as fromStore from '../store/reducers';
import * as supportTicketActions from '../store/actions';
import * as workspaceActions from '../../pillar/workspace/store/actions';
import * as errorActions from '../../pillar/common/actions/ActionError';
import { FormGroup, Validators } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { ActionBase } from '../../core/store/action/ActionBase';
import { DatePipe } from '@angular/common';
import { AutoSaveFormBuilder } from '../../pillar/workspace/AutoSaveFormBuilder';
import { CustomOption, QuillModules, QuillEditorComponent } from 'ngx-quill';
import { SupportTicketInformationModel } from '../models/SupportTicketInformationModel';
import { maxPlainTextLength } from "../../common/validators/maxPlainTextLengthValidator";

@Component({
  selector: 'app-support-ticket-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => SupportTicketTileComponent) }],
  templateUrl: './support-ticket-tile.component.html',
  styleUrls: ['./support-ticket-tile.component.scss']
})
export class SupportTicketTileComponent extends TileComponent implements OnInit, OnDestroy {
  supportTicketInformation: SupportTicketInformationModel;
  key: string;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  supportTicketInformationForm: FormGroup;
  supportTicketEmail: string;
  actionIdentifiers: string[] = [];
  editorModules = {
    toolbar: false
  }
  currentDate: Date;
  maxMessageToUsersLength = 1000;
  cursorPosition: number = 0;
  disclaimerLength: number;

  viewSupportTicketConfigurationPermission: string = 'ConfigurationModule.SupportTicket:View';
  editSupportTicketConfigurationPermission: string = 'ConfigurationModule.SupportTicket:Edit';

  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  constructor(
    private store: Store<any>,
    private router: Router,
    private formBuilder: AutoSaveFormBuilder,
    private actions$: Actions,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    elementRef: ElementRef,) {
    super(elementRef);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  ngOnInit() {
    this.store.dispatch(new supportTicketActions.GetSupportTicketInformationAction());

    this.actions$.ofType(supportTicketActions.GET_SUPPORT_TICKET_INFORMATION_SUCCESS_ACTION)
      .takeUntil(this.destroyed$)
      .subscribe((a: supportTicketActions.GetSupportTicketInformationSuccessAction) => {
        var supportTicketInformation = a.payload.supportTicketInformation;
        if (supportTicketInformation != null) {
          this.supportTicketInformation = supportTicketInformation;
          if (supportTicketInformation.supportTicketEmailAddress) {
            this.supportTicketEmail = supportTicketInformation.supportTicketEmailAddress;
          }
        }
        this.supportTicketInformation = a.payload.supportTicketInformation;
      });
  }

  edit(): void {
    this.router.navigateByUrl('support-ticket-workspace');
  }
}



// WEBPACK FOOTER //
// ./src/app/security/components/support-ticket-tile.component.ts